import { StarIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { type ChangeEvent } from "react";
import { useIntl } from "react-intl";

import { Checkbox } from "@/components/Checkbox/Checkbox";

const STAR_OPTIONS = [1, 2, 3, 4, 5];

type Props = {
  selectedClasses?: number[];
  onChange: (
    event: React.SyntheticEvent,
    checked: boolean,
    option: number,
  ) => void;
};

export const StarRatingFilter = ({ selectedClasses = [], onChange }: Props) => {
  const intl = useIntl();
  const isUnratedSelected = selectedClasses.includes(0);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex gap-2">
        {STAR_OPTIONS.map((option) => {
          const isSelected = selectedClasses.includes(option);
          return (
            <button
              key={option}
              type="button"
              aria-pressed={isSelected}
              aria-label={intl.formatMessage(
                {
                  defaultMessage:
                    "{count, plural, one {# star} other {# stars}}",
                  description: "Hotel star rating filter button label",
                },
                { count: option },
              )}
              onClick={(e) => onChange(e, !isSelected, option)}
              className={clsx(
                "flex flex-1 items-center justify-center gap-1 rounded-full border border-surface-accent-strong px-2 py-2",
                isSelected ? "bg-surface-accent-softer" : "bg-transparent",
              )}
            >
              <span className="text-base leading-snug font-medium tracking-[0.15px] text-text-primary">
                {option}
              </span>
              <StarIcon
                size={16}
                weight="fill"
                color="var(--color-core-caution-400)"
                className="shrink-0"
              />
            </button>
          );
        })}
      </div>

      <label className="flex items-center gap-2">
        <Checkbox
          checked={isUnratedSelected}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(e, e.target.checked, 0)
          }
          density="compact"
        />
        <span className="text-base font-medium text-text-primary">
          {intl.formatMessage({
            defaultMessage: "Hotel without stars",
            description:
              "Hotel class filter option: unrated/no-star properties",
          })}
        </span>
      </label>
    </div>
  );
};
